import ErrorFallback from "ErrorFallback";
import React from "react";
import { captureException } from "@sentry/react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type State = {
  hasError: boolean;
  error?: Error;
};

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    captureException(error, {
      level: "error",
      extra: {
        componentStack: info.componentStack,
      },
      tags: {
        source: "web-error-boundary",
      },
    });
    console.warn("Uncaught error:", error, info);
  }

  resetError = () => {
    this.setState({ hasError: false, error: undefined });
  };

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? <ErrorFallback resetError={this.resetError} />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
